import { render, staticRenderFns } from "./SubMessageBox.vue?vue&type=template&id=475aa2dc"
import script from "./SubMessageBox.vue?vue&type=script&lang=js"
export * from "./SubMessageBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports